const BOT_PATTERNS = [
  'googlebot',
  'yandexbot',
  'gptbot',
  'chatgpt',
  'bingbot',
  'duckduckbot',
  'applebot',
  'bytespider',
  'facebookexternalhit',
  'twitterbot',
  'ccbot',
  'bot',
  'crawler',
  'spider',
]

export function isBot(userAgent: string | null | undefined): boolean {
  if (!userAgent) {
    return false
  }
  const ua = userAgent.toLowerCase()
  return BOT_PATTERNS.some((pattern) => ua.includes(pattern))
}
